/* ==========================================================================
   Involpro product page (Motrox): option pills over big variant matrices (up to
   1,800 variants, indexed for O(1) lookups), price/URL/media sync, Afterpay
   (Square on-site messaging, AUD only), delivery date estimate in business days,
   dated deal countdown, AJAX add to cart, gallery (full screen: ivp-ui.js lightbox), sticky bar.
   Needs ivp-ui.js (window.IvpTheme).
   ========================================================================== */
(function () {
  'use strict';
  var d = document;
  var M = window.IvpTheme || {};
  function qs(s, el) { return (el || d).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }
  function money(c) { return M.formatMoney ? M.formatMoney(c) : '$' + (c / 100).toFixed(2); }

  function initProduct(root) {
    var isLanding = root.hasAttribute('data-ivp-landing');
    // Made to measure (client, 7 Oct 2026): a "custom-made" option value goes in the cart like any other, with the line
    // note "Made to measure: We'll contact you for your measurements"; the note panel and the note follow the choice
    var customOn = root.hasAttribute('data-ivp-custom');
    function isCustom(v) { return customOn && !!v && v.options.some(function (o) { return /custom/i.test(o); }); }
    var mtm = qs('[data-ivp-mtm]', root);
    var mtmProp = qs('[data-ivp-mtm-prop]', root);
    // Thermal liner add-on (client, 7 Oct 2026): while the switch is on, the liner goes in the same cart request as the
    // garment, with the line note "For: <garment – choice>"; express checkout hides (it would buy the garment alone)
    var liner = qs('[data-ivp-liner]', root);
    var linerCheck = liner && qs('[data-ivp-liner-check]', liner);
    function linerWanted() { return !!(linerCheck && linerCheck.checked); }
    // build preferences: a select counts when it's off its first (default) option, a details box when it has text
    function prefSet(el) { return !el.disabled && (el.tagName === 'SELECT' ? el.selectedIndex > 0 : !!el.value.trim()); }
    function prefsChanged() { return qsa('[data-ivp-lineprop]', root).some(prefSet); }
    function syncDynamic(v) { var dyn = qs('[data-ivp-dynamic]', root); if (dyn) dyn.hidden = !v.available || isCustom(v) || linerWanted() || prefsChanged(); }
    var jsonEl = qs('[data-ivp-product-json]', root);
    if (!jsonEl) return;
    var raw = JSON.parse(jsonEl.textContent);
    // [id, options, price, compare_at, available, media_id, sku]
    var variants = [], index = {};
    function add(list) {
      list.forEach(function (a) {
        var key = a[1].join('\u0001');
        if (index[key]) return;
        var v = { id: a[0], options: a[1], price: a[2], compare: a[3], available: a[4], media: a[5], sku: a[6], title: a[1].join(' / ') };
        variants.push(v);
        index[key] = v;
      });
    }
    add(raw.v);
    // Over 250 variants Liquid only lists the first 250 (plus the neighbours of the current choice), so the rest
    // are fetched per choice from sections/ivp-variant-data.liquid (Section Rendering API, option value ids)
    var partial = raw.total > variants.length;
    var pending = null, nearLoaded = {};
    function fetchNear() {
      if (pending) pending.abort();
      var ctrl = pending = new AbortController();
      var ids = fieldsets.map(function (fs) { var c = qs('input:checked', fs); return c && c.getAttribute('data-option-value-id'); }).filter(Boolean).join(',');
      return fetch(raw.url + '?section_id=ivp-variant-data&option_values=' + ids, { signal: ctrl.signal })
        .then(function (r) { if (!r.ok) throw new Error('variant data ' + r.status); return r.text(); })
        .then(function (html) {
          var m = html.match(/<script[^>]*data-ivp-variant-data[^>]*>([\s\S]*?)<\/script>/);
          if (!m) throw new Error('no variant data');
          var data = JSON.parse(m[1]);
          add(data.v);
          if (pending === ctrl) pending = null;
          var sel = variants.filter(function (v) { return v.id === data.sel; })[0] || null;
          if (sel) nearLoaded[sel.options.join('\u0001')] = true;
          return sel;
        });
    }
    var form = qs('[data-ivp-product-form]', root);
    var idInput = qs('[data-ivp-variant-id]', root);
    var atc = qs('[data-ivp-atc]', root);
    var atcLabel = qs('[data-ivp-atc-label]', root);
    var qtyInput = qs('[data-ivp-qty]', root);
    var errorEl = qs('[data-ivp-form-error]', root);
    var fieldsets = qsa('[data-ivp-option]', root);
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    if (partial) nearLoaded[current.options.join('\u0001')] = true; // the page JSON carries this choice's neighbours

    /* ---------- Variants ---------- */
    function selectedOptions() { return fieldsets.map(function (fs) { var c = qs('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(opts) { return index[opts.join('\u0001')]; }
    function bestVariant(opts, fixed) {
      var best = null, score = -1;
      variants.forEach(function (v) {
        if (v.options[fixed] !== opts[fixed]) return;
        var s = v.options.reduce(function (n, o, i) { return n + (o === opts[i] ? 1 : 0); }, 0) + (v.available ? 0.5 : 0);
        if (s > score) { score = s; best = v; }
      });
      return best;
    }
    function setRadios(v) { fieldsets.forEach(function (fs, i) { qsa('input', fs).forEach(function (r) { r.checked = r.value === v.options[i]; }); }); }
    function markAvailability(opts) {
      // big products: until the neighbours of this choice have arrived, a combination we have not seen is unknown,
      // not missing, so its pill keeps its state (no flash of struck-through options)
      var complete = !partial || nearLoaded[opts.join('\u0001')];
      fieldsets.forEach(function (fs, i) {
        qsa('input', fs).forEach(function (r) {
          var test = opts.slice(); test[i] = r.value;
          var v = findVariant(test);
          if (!v && !complete) return;
          var label = r.nextElementSibling;
          if (label) {
            label.classList.toggle('is-unavailable', !v || !v.available);
            label.title = (!v ? 'Not available in this combination' : (!v.available ? 'Sold out' : ''));
          }
        });
        var out = qs('[data-ivp-option-value]', fs);
        if (out) out.textContent = opts[i] || '';
        // Biker / Fashion cards under a Version option: the chosen version is highlighted
        qsa('[data-ivp-ver]', fs).forEach(function (c) { c.classList.toggle('is-on', (opts[i] || '').toLowerCase().indexOf(c.getAttribute('data-ivp-ver')) > -1); });
      });
    }
    function renderPrice(v) {
      var wrap = qs('[data-ivp-price-wrap] [data-ivp-price]', root);
      if (!wrap) return;
      if (v.price === 0 && !v.available) { wrap.classList.remove('ivp-price--sale'); wrap.innerHTML = '<span class="ivp-price__soon">Coming soon</span>'; return; }
      var sale = v.compare > v.price;
      wrap.classList.toggle('ivp-price--sale', sale);
      var html = '<span class="ivp-price__current">' + money(v.price) + '</span>';
      if (sale) html += '<s class="ivp-price__compare">' + money(v.compare) + '</s><span class="ivp-price__save">Save ' + Math.round((v.compare - v.price) * 100 / v.compare) + '%</span>';
      wrap.innerHTML = html;
    }
    // Back in stock: the sign-up shows while the choice is sold out and tags the exact variant (restock-<handle>-<title>)
    var rs = qs('[data-ivp-restock]', root);
    var rsTags = rs && qs('[data-ivp-restock-tags]', rs);
    var rsWhat = rs && qs('[data-ivp-restock-what]', rs);
    function handleize(s) { return String(s).toLowerCase().replace(/['’"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function restock(v) {
      if (!rs) return;
      var show = !!v && !v.available && v.price > 0 && !isCustom(v);
      rs.hidden = !show;
      if (!show) return;
      if (rsTags) rsTags.value = rsTags.getAttribute('data-base') + ',' + rsTags.getAttribute('data-handle') + '-' + handleize(v.title);
      if (rsWhat) rsWhat.textContent = v.title;
    }
    function update(v, opts) {
      current = v;
      idInput.value = v.id;
      renderPrice(v);
      var label = v.available ? 'Add to cart' : (v.price === 0 ? 'Coming soon' : 'Sold out');
      if (mtm) mtm.hidden = !isCustom(v);
      if (mtmProp) mtmProp.disabled = !isCustom(v);
      atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = label;
      // the sticky bar and express checkout follow the selected variant (they said "Add to cart" on sold-out products)
      // landing pages: the sticky button scrolls to the buy box ("Choose your size"), so its label stays
      var sb = qs('[data-ivp-sticky-add]'); if (sb && !isLanding) { sb.disabled = !v.available; sb.textContent = label; }
      syncDynamic(v); // express checkout would skip the measurements note and the liner
      if (typeof renderDelivery === 'function') renderDelivery(v);
      restock(v);
      markAvailability(opts || v.options);
      var sp = qs('[data-ivp-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var sv = qs('[data-ivp-sticky-variant]'); if (sv) sv.textContent = v.title;
      if (v.media) gallery.goToMedia(v.media);
      afterpay.render(v);
      if (window.history && history.replaceState && !root.hasAttribute('data-ivp-landing')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function (fs, i) {
      fs.addEventListener('change', function () {
        var opts = selectedOptions();
        var v = findVariant(opts);
        if (!partial) {
          if (!v) { v = bestVariant(opts, i); if (v) setRadios(v); }
          if (v) update(v, v.options);
          return;
        }
        // big product: show what is already known, then settle on Shopify's answer for this choice (it also brings
        // the neighbours, so the other options' availability is right for the new choice)
        if (v) update(v, v.options); else atc.disabled = true;
        fetchNear().then(function (sel) {
          var now = selectedOptions();
          var w = findVariant(now);
          if (!w) w = sel && sel.options[i] === now[i] ? sel : bestVariant(now, i);
          if (!w) w = current;
          setRadios(w);
          if (w !== current) update(w, w.options);
          else { atc.disabled = !w.available; markAvailability(w.options); }
        }).catch(function (err) {
          if (err && err.name === 'AbortError') return;
          var b = v || bestVariant(opts, i);
          if (b) { if (b !== v) setRadios(b); update(b, b.options); }
        });
      });
    });

    /* ---------- Back in stock: after the sign-up Shopify returns to the product URL without ?variant, so the page
       opened on the first available choice and the sold-out choice's thank-you was out of sight (user test,
       7 Oct 2026). Remember the choice on submit and choose it again on the way back. ---------- */
    var rsForm = rs && qs('form', rs);
    var RS_KEY = 'ivpRestockVariant';
    if (rsForm) rsForm.addEventListener('submit', function () { try { sessionStorage.setItem(RS_KEY, String(current.id)); } catch (e) {} });
    if (rs && /customer_posted=true/.test(window.location.search) && window.location.hash === '#IvpRestock') {
      var kept = null;
      try { kept = sessionStorage.getItem(RS_KEY); sessionStorage.removeItem(RS_KEY); } catch (e) {}
      var back = kept && variants.filter(function (x) { return String(x.id) === kept; })[0];
      if (back && back !== current) { setRadios(back); update(back, back.options); }
      if (!rs.hidden) rs.scrollIntoView({ block: 'center' });
    }

    if (linerCheck) linerCheck.addEventListener('change', function () { syncDynamic(current); });
    // a preference with a details box ("My own colours" -> describe them) opens it for any option but the first;
    // any changed preference hides express checkout, which would skip the line notes
    qsa('[data-ivp-lineprop]', root).forEach(function (el) {
      var detail = el.tagName === 'SELECT' && el.parentElement.nextElementSibling;
      if (detail && !detail.hasAttribute('data-ivp-pref-detail')) detail = null;
      function sync() {
        if (detail) {
          var on = el.selectedIndex > 0, box = qs('[data-ivp-lineprop]', detail);
          detail.hidden = !on; box.disabled = !on;
        }
        syncDynamic(current);
      }
      el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'input', sync);
      sync();
    });

    /* ---------- Quantity ---------- */
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-ivp-qty-step]');
      if (!step || !qtyInput) return;
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-ivp-qty-step'), 10));
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); });

    /* ---------- Submit ---------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!M.cart) { form.submit(); return; }
      if (errorEl) errorEl.hidden = true;
      M.setLoading(atc, true);
      var line = { id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 };
      if (isCustom(current) && mtmProp && mtmProp.value) line.properties = { 'Made to measure': mtmProp.value };
      // build preferences: only a change from the first (default) option, or a filled details box, goes on the line
      qsa('[data-ivp-lineprop]', root).forEach(function (el) {
        if (!prefSet(el)) return;
        line.properties = line.properties || {};
        line.properties[el.getAttribute('data-ivp-lineprop')] = el.value.trim();
      });
      var lines = [line];
      if (linerWanted()) {
        var lp = {};
        lp[liner.getAttribute('data-prop') || 'For'] = liner.getAttribute('data-for') + ' – ' + current.title;
        lines.push({ id: parseInt(liner.getAttribute('data-variant-id'), 10), quantity: line.quantity, properties: lp });
      }
      M.cart.add(lines).then(function () {
        M.setLoading(atc, false);
        M.openCart(atc);
      }).catch(function (err) {
        M.setLoading(atc, false);
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else M.toast(err.message);
      });
    });

    /* ---------- Afterpay (Square on-site messaging; the element is rebuilt per variant) ---------- */
    var afterpay = (function () {
      var box = qs('[data-ivp-afterpay]', root);
      if (!box) return { render: function () {} };
      var loaded = false;
      function load() {
        if (loaded) return; loaded = true;
        var s = d.createElement('script'); s.src = 'https://js.squarecdn.com/square-marketplace.js'; s.async = true; d.head.appendChild(s);
      }
      function render(v) {
        box.innerHTML = '';
        // Afterpay only for a variant that can be bought, at $1 or more (it showed "orders between $1 - $4,000" at $0)
        box.hidden = !v.available || v.price < 100;
        if (box.hidden) return;
        var el = d.createElement('square-placement');
        el.setAttribute('data-mpid', box.getAttribute('data-mpid'));
        el.setAttribute('data-placement-id', box.getAttribute('data-placement'));
        el.setAttribute('data-page-type', 'product');
        el.setAttribute('data-amount', (v.price / 100).toFixed(2));
        el.setAttribute('data-currency', 'AUD');
        el.setAttribute('data-consumer-locale', 'en-AU');
        el.setAttribute('data-item-skus', v.sku || '');
        el.setAttribute('data-item-categories', box.getAttribute('data-type') || '');
        el.setAttribute('data-is-eligible', 'true');
        box.appendChild(el);
        load();
      }
      // Load after the page has painted (it is below the price, not the LCP)
      if ('requestIdleCallback' in window) requestIdleCallback(function () { render(current); }, { timeout: 2500 });
      else setTimeout(function () { render(current); }, 1200);
      return { render: function (v) { if (loaded) render(v); } };
    })();

    /* ---------- Delivery estimate: business days from today (weekends skipped), Sydney time ----------
       A custom-made choice on a stocked product switches the promise and the estimate to 15-19 business days
       (data-dmin-cm / data-dmax-cm and the data-c text of each [data-ivp-dmsg]; user, 10 Oct 2026) */
    function renderDelivery(v) {
      var cm = isCustom(v);
      qsa('[data-ivp-dmsg]', root).forEach(function (el) { el.textContent = el.getAttribute(cm ? 'data-c' : 'data-n'); });
      var eta = qs('[data-ivp-eta]', root);
      var min = parseInt(root.getAttribute(cm ? 'data-dmin-cm' : 'data-dmin'), 10), max = parseInt(root.getAttribute(cm ? 'data-dmax-cm' : 'data-dmax'), 10);
      if (!eta || !min || !max || root.getAttribute('data-dkind') === 'suit') return;
      function addBiz(date, n) { var x = new Date(date); while (n > 0) { x.setDate(x.getDate() + 1); var g = x.getDay(); if (g !== 0 && g !== 6) n--; } return x; }
      var now = new Date();
      var fmt = function (x) { return x.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }); };
      eta.textContent = 'Order today, estimated arrival ' + fmt(addBiz(now, min)) + ' to ' + fmt(addBiz(now, max)) + '. ';
      eta.hidden = false;
    }
    renderDelivery(current);

    /* ---------- Deal countdown (real end time from the product metafield) ---------- */
    qsa('[data-ivp-deal]', root).forEach(function (deal) {
      var end = parseInt(deal.getAttribute('data-end'), 10) * 1000;
      var el = { d: qs('[data-u="d"]', deal), h: qs('[data-u="h"]', deal), m: qs('[data-u="m"]', deal) };
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { deal.remove(); return false; }
        el.d.textContent = Math.floor(left / 86400); el.h.textContent = Math.floor(left % 86400 / 3600); el.m.textContent = Math.floor(left % 3600 / 60);
        return true;
      }
      if (tick()) { var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 30000); }
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ivp-copy]');
      if (!b) return;
      var code = b.getAttribute('data-ivp-copy'), lbl = qs('[data-ivp-copy-label]', b);
      var done = function () { if (lbl) { lbl.textContent = 'Copied'; setTimeout(function () { lbl.textContent = 'Copy'; }, 2000); } };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {});
    });

    /* ---------- Gallery ---------- */
    var gallery = initGallery(root);

    /* ---------- Sticky add to cart ---------- */
    var bar = qs('[data-ivp-sticky-atc]', root);
    if (bar) {
      d.body.appendChild(bar);
      var stickyBtn = qs('[data-ivp-sticky-add]', bar);
      var buyEl = qs('.ivp-pdp__buy', root) || atc;
      // Checked on scroll (not an IntersectionObserver: a jump back to the top never crossed the edge, so the bar
      // stayed up). Product page: once the buy buttons are above the screen. Landing page: after the first screen,
      // whenever the buy box itself is not on screen.
      var syncSticky = function () {
        var r = buyEl.getBoundingClientRect(), vh = window.innerHeight;
        var show = isLanding ? (window.scrollY > vh * 0.9 && !(root.getBoundingClientRect().top < vh && root.getBoundingClientRect().bottom > 0)) : r.bottom < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
        d.body.classList.toggle('ivp-has-sticky-atc', show);
      };
      var ticking = false;
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; syncSticky(); }); } }, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
      stickyBtn.addEventListener('click', function () {
        if (isLanding) { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }

    markAvailability(current.options);
  }

  function initGallery(root) {
    var api = { goToMedia: function () {} };
    var g = qs('[data-ivp-gallery]', root);
    if (!g) return api;
    var track = qs('[data-ivp-gallery-track]', g);
    var slides = qsa('.ivp-gallery__slide', track);
    var thumbs = qsa('[data-ivp-thumb]', g);
    var counter = qs('[data-ivp-gallery-index]', g);
    var index = 0;
    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      index = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (counter) counter.textContent = i + 1;
      var t = thumbs[i];
      if (t && t.parentNode.scrollTo) {
        var p = t.parentNode;
        if (p.scrollHeight > p.clientHeight + 2) p.scrollTo({ top: t.offsetTop - p.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
        else if (p.scrollWidth > p.clientWidth + 2) p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
      slides.forEach(function (s, n) { if (n !== i) qsa('video', s).forEach(function (v) { v.pause(); }); });
    }
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index) setActive(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-ivp-thumb'), 10)); }); });
    var prev = qs('[data-ivp-gallery-prev]', g), next = qs('[data-ivp-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });
    // full-screen view: the shared lightbox in ivp-ui.js ([data-ivp-lbx] links on the slides)
    api.goToMedia = function (mediaId) {
      var s = slides.filter(function (x) { return x.getAttribute('data-media-id') === String(mediaId); })[0];
      if (s) go(slides.indexOf(s));
    };
    return api;
  }

  function boot() { qsa('[data-ivp-product]').forEach(initProduct); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
